module.exports = __webpack_public_path__ + "img/19_12.b19d28bf.png";